<!-- eslint-disable vue/no-v-html -->
<template>
	<section
		v-if="cfg"
		:class="['my-5', { 'bg-primary-section': isFiniti }]"
		:style="isFiniti ? finitiStyle : null">
		<h2
			class="text-center bolder-text mb-4"
			v-html="text.title" />
		<div class="row">
			<div
				v-for="(col, cIdx) in columns"
				:key="'ing-col-'+cIdx"
				class="col-md-4">
				<ul class="list-unstyled mb-0">
					<li
						v-for="(b, i) in col"
						:key="'ing-'+cIdx+'-'+i"
						class="d-flex align-items-start mb-2">
						<span
							class="me-2 d-inline-flex align-items-center justify-content-center"
							aria-hidden="true">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="18"
								height="18"
								viewBox="0 0 20 20">
								<path
									d="M10,20A10,10,0,1,0,0,10,10,10,0,0,0,10,20ZM14.414,8.164l-5,5a.934.934,0,0,1-1.324,0l-2.5-2.5A.936.936,0,0,1,6.914,9.34L8.75,11.176l4.336-4.34A.936.936,0,0,1,14.41,8.16Z"
									fill="currentColor" />
							</svg>
						</span>
						<span v-html="b" />
					</li>
				</ul>
			</div>
		</div>
	</section>
</template>

<script>
import { PRODUCT_PAGES } from '@/settings/JnsLandingPages';
import { JnsLandingPages } from '@/translations';
import Page from '@/views/JnsLandingPages/mixins/Page';
import Storage from '@/views/JnsLandingPages/mixins/Storage';
import Replacements from '@/views/JnsLandingPages/mixins/Replacements';

export default {
	name: 'KeyIngredientsFocus',
	messages: [JnsLandingPages],
	mixins: [Page, Storage, Replacements],
	computed: {
		cfg() { return PRODUCT_PAGES[this.pageName]?.keyIngredientsFocus || null; },
		isFiniti() {
			return (this.pageName || '').toLowerCase() === 'finiti';
		},
		finitiStyle() {
			return {
				backgroundColor: '#C51C8B',
				color: '#ffffff',
				borderRadius: '8px',
				padding: '2rem 1rem',
			};
		},
		text() {
			if (!this.cfg) return { title: '' };
			return { title: this.applyReplacements(this.translate(this.cfg.title || '')) };
		},
		columns() {
			if (!this.cfg) return [];
			const cols = this.cfg.columns || [];
			return cols.map((col) => (col || []).map((k) => this.applyReplacements(this.translate(k))).filter(Boolean));
		},
	},
};
</script>

<style scoped>
.bolder-text { font-weight: bolder; }

/* Primary background variant used only for FINITI */
.bg-primary-section {
    background-color: var(--jlp-primary-color);
    color: #fff;
    border-radius: 8px;
    padding: 2rem 1rem;
}
</style>
